<app-search-layout #searchLayout>
  <app-search-navbar
    searchNavbar
    *ngIf="(sitesLoaded$ | async) === true"
    [searchFieldList]="searchFieldList"
    [searchAction]="searchAction"
    [updateSearchValueAction]="updateSearchValueAction"
    [pageSize]="pageSize"
  ></app-search-navbar>
  <router-outlet searchContent></router-outlet>
</app-search-layout>
